import $ from "jquery";
import _ from "underscore";
import run from "../../../../../utilities/run";
import render from "../../../../../utilities/render";
import { keyDefaultFalseOption } from '../../../../../utilities/general';

let actionCellDropdownTemplate = require('../html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../html/utilRenderTemplates/actionHeaderDropdown.html');


export function createDropdownRenderers(dataList) {

  function renderActionCellList(list) {
    let renderedList;
    renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: keyDefaultFalseOption(item, "disabled")
        }
      )
    });
    return renderedList.join('');
  };

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = dataList[data];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget),
        index: meta.row
      }
    );
    return newRender;
  };

  function renderActionHeaderWrap() {
    let statusTarget = dataList['all'];
    let newRender;
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget)
      }
    );
    return newRender;
  };

  return {
    renderActionWrap,
    renderActionHeaderWrap,
  }
}


// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/html/doorLookup/utilityScripts/renderers.js